import { useAudio } from "../audio/useAudio";
import { Scene } from "../render/Scene";
import { KeyboardControl } from "../ui/KeyboardControl";
import { useSettingsStore } from "./settingsStore";
import { TuningConsole } from "../ui/TuningConsole";
import { Hand } from "../ui/cards/Hand";
import { Hud } from "../ui/hud/Hud";
import { RunEnd } from "../ui/hud/RunEnd";
import { SetupScreen } from "../ui/hud/SetupScreen";
import { StagePicker } from "../ui/hud/StagePicker";
import { Notice, PipeTargeting, Toast } from "../ui/hud/Toast";
import { TileInspector } from "../ui/hud/TileInspector";
import { RunOver } from "../ui/run/RunOver";
import { SettingsPanel } from "../ui/settings/SettingsPanel";
import { Tutorial } from "../ui/tutorial/Tutorial";
import { PathwayPick } from "../ui/run/PathwayPick";
import { ShopScreen } from "../ui/run/ShopScreen";
import "./app.css";

/**
 * Composition root. The 3D stage fills the viewport; the diegetic DOM HUD,
 * job sheet, card hand and run feedback overlay it.
 *
 * PathwayPick opens a run (only when the era pool offers pathways). The other
 * run screens stack in the order a batch ends: RunEnd banks the
 * batch, then either the shop opens or the shift is over. Each renders only in
 * its own run status, so at most one is ever on screen.
 */
export function App() {
  useAudio();
  const reduceMotion = useSettingsStore((s) => s.reduceMotion);

  // The setting, not just the media query: someone may want less motion here
  // and not system-wide, and the two must not fight.
  return (
    <div className={`reagent-app${reduceMotion ? " reduce-motion" : ""}`}>
      <Scene />
      <StagePicker />
      <SetupScreen />
      <Hud />
      <TileInspector />
      <Hand />
      <PipeTargeting />
      <Toast />
      <Notice />
      <RunEnd />
      <PathwayPick />
      <ShopScreen />
      <RunOver />
      <KeyboardControl />
      <Tutorial />
      <SettingsPanel />
      <TuningConsole />
    </div>
  );
}
